var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFabHeadsetWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.252,
    height: 30.671,
    viewBox: "0 0 34.252 30.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-headset",
    "data-name": "Icon awesome-headset",
    d: "M12.845,12.46A2.038,2.038,0,0,0,10.7,10.543H9.633a4.076,4.076,0,0,0-4.282,3.834v2.875a4.076,4.076,0,0,0,4.282,3.834H10.7a2.038,2.038,0,0,0,2.141-1.917Zm11.774,8.626A4.076,4.076,0,0,0,28.9,17.253V14.377a4.076,4.076,0,0,0-4.282-3.834h-1.07a2.038,2.038,0,0,0-2.141,1.917V19.17a2.038,2.038,0,0,0,2.141,1.917ZM17.126,0C7.572,0,.306,7.118,0,15.336v.958a1.019,1.019,0,0,0,1.07.958h1.07a1.019,1.019,0,0,0,1.07-.958v-.958c0-6.87,6.242-12.46,13.915-12.46s13.915,5.59,13.915,12.46h-.008c.005.146.008,9.927.008,9.927A2.693,2.693,0,0,1,28.213,27.8h-6.8A3.057,3.057,0,0,0,18.2,24.92H16.056A3.057,3.057,0,0,0,12.845,27.8a3.057,3.057,0,0,0,3.211,2.875H28.213c3.336,0,6.04-2.421,6.04-5.408V15.336C33.946,7.118,26.681,0,17.126,0Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabHeadsetWhite);
export default __webpack_public_path__ + "static/media/fab-headset-white.e3ca30d5121559f8c92f3e54b8890056.svg";
export { ForwardRef as ReactComponent };